module.exports = __webpack_public_path__ + "assets/img/doctor.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/doctor.jpg
// module id = 1953
// module chunks = 0